import React from 'react';
import { Button } from '@/components/ui/button';
import { X, DollarSign } from 'lucide-react';
import { cn } from '@/lib/utils';
import { 
  colors, 
  shadows, 
  borders, 
  typography
} from '@/components/business/design-system/businessDesignTokens';

interface PricingModalHeaderProps {
  onClose: () => void;
}

export function PricingModalHeader({ onClose }: PricingModalHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <div className={cn(
          "w-10 h-10 rounded-lg flex items-center justify-center",
          `bg-gradient-to-br from-${colors.primary.main} to-${colors.primary.light}`,
          shadows.colored.blue
        )}>
          <DollarSign className="w-5 h-5 text-white" />
        </div>
        <h3 className={cn(typography.h4, `text-${colors.neutral[900]}`)}>
          Configure Pricing
        </h3>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onClose}
        className={cn(
          "hover:bg-slate-100 rounded-lg",
          borders.focus.primary
        )}
        aria-label="Close pricing modal"
      >
        <X className="w-4 h-4" />
      </Button>
    </div>
  );
}
